export default __webpack_public_path__ + "static/media/element_spec_24.a1297c14.webp";